"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VipOrderFormRoot = void 0;
var _mui = require("@ori-ui/mui");
const VipOrderFormRoot = exports.VipOrderFormRoot = (0, _mui.styled)('form')(({
  theme
}) => ({
  alignItems: 'center',
  columnGap: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  overflowX: 'hidden',
  gap: theme.spacing(3)
}));